/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown>, languages: NonNullable<unknown> }} Additional_Cost_Per_MinuteInputs */



/**
* | output |
* | --- |
* | "Additional Cost: ${cost}/minute ({languages})" |
*
* @param {Additional_Cost_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const additional_cost_per_minute = /** @type {((inputs: Additional_Cost_Per_MinuteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additional_Cost_Per_MinuteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Coût supplémentaire : $${i?.cost}/minute (${i?.languages})`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zusätzliche Kosten: $${i?.cost}/Minute (${i?.languages})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Costo aggiuntivo: $${i?.cost}/minuto (${i?.languages})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Дополнительная стоимость: $${i?.cost}/минута (${i?.languages})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Costo adicional: $${i?.cost}/minuto (${i?.languages})`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`额外费用：$${i?.cost}/分钟 (${i?.languages})`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`追加料金: $${i?.cost}/分 (${i?.languages})`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अतिरिक्त लागत: $${i?.cost}/मिनट (${i?.languages})`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Custo adicional: $${i?.cost}/minuto (${i?.languages})`)
	return /** @type {LocalizedString} */ (`Additional Cost: $${i?.cost}/minute (${i?.languages})`)
});